// extracted by mini-css-extract-plugin
module.exports = {"root":"az_vhb","text":"az_whb","pulse":"az_xhb","wave":"az_yhb"};